import { useNavigate } from "react-router-dom";
import { BiChevronLeft } from "react-icons/bi";
import {
  MdOutlineInsights,
  MdOutlineAddTask,
  MdOutlineTableView,
  MdOutlineShoppingCart,
  MdOutlineArrowForwardIos,
  MdOutlineSmartButton,
} from "react-icons/md";
import str1 from "../../asset/Images/faq/Insights/strategy/1.png";
import str2 from "../../asset/Images/faq/Insights/strategy/2.png";
import str3 from "../../asset/Images/faq/Insights/strategy/3.png";
import str4 from "../../asset/Images/faq/Insights/strategy/4.png";
import { LazyLoadImage } from "react-lazy-load-image-component";
import styles from "../../styles/Components/faq/InsightStrategyHelp.module.css";

function InsightStrategyHelp() {
  const navigate = useNavigate();

  return (
    <div className={styles.helpWrapper}>
      <div className={styles.backBtn} onClick={() => navigate("/faq/all")}>
        <BiChevronLeft />
        <span>Back to Help Center</span>
      </div>

      <div className={`${styles.heroCard} ${styles.heroInsight}`}>
        <div className={`${styles.heroIcon} ${styles.heroIconInsight}`}>
          <MdOutlineInsights />
        </div>
        <div className={styles.heroContent}>
          {/* <div className={styles.heroEyebrow}>
            <MdOutlineInsights />
            Insights & Strategy
          </div> */}
          <h3 className={styles.heroTitle}>Create Strategy</h3>
          <p className={styles.heroDesc}>
            The Strategy Builder page allows you to create and manage AI-powered
            trading strategies.
          </p>
        </div>
      </div>

      <div className={styles.stepContainer}>
        <div className={styles.stepHeader}>
          <div className={`${styles.stepNumWrap} ${styles.stepNumInsight}`}>
            <span className={styles.stepNum}>1</span>
          </div>
          <div className={styles.stepInfo}>
            <h4 className={styles.stepTitle}>Top Action Bar</h4>
            <div className={styles.stepTag}>
              <MdOutlineSmartButton />
              Quick Actions
            </div>
          </div>
        </div>
        <div className={styles.subStepWrapper}>
          <div className={styles.subStepContainer}>
            <p className={styles.helpLead}>
              The buttons at the top allow you to manage your trading strategies
              effectively:
            </p>
            <ul className={styles.helpList}>
              <li>
                <strong>Create:</strong> Start building a new strategy from
                scratch.
              </li>
              <li>
                <strong>Manage:</strong> View and edit your existing strategies.
              </li>
              <li>
                <strong>Templates:</strong> Access predefined strategies to
                apply or modify.
              </li>
              <li>
                <strong>Refresh:</strong> Update the page to reflect the latest
                data and signals.
              </li>
            </ul>
            <div className={styles.imageWrap}>
              <LazyLoadImage
                src={str1}
                alt="create bot"
                effect="blur"
                wrapperClassName="imageContainer"
              />
            </div>
          </div>
        </div>
      </div>

      <div className={styles.stepContainer}>
        <div className={styles.stepHeader}>
          <div className={`${styles.stepNumWrap} ${styles.stepNumInsight}`}>
            <span className={styles.stepNum}>2</span>
          </div>
          <div className={styles.stepInfo}>
            <h4 className={styles.stepTitle}>Table Header Summary</h4>
            <div className={`${styles.stepTag} ${styles.tagHeader}`}>
              <MdOutlineArrowForwardIos />
              Above Table
            </div>
          </div>
        </div>
        <div className={styles.subStepWrapper}>
          <p className={styles.helpLead}>
            The section above the table shows two parts, as follows:
          </p>

          <div className={styles.subSection}>
            <div className={styles.subSectionBadge}>
              <MdOutlineInsights />
            </div>
            <div className={styles.subStepContainer}>
              <p className={styles.subStepTitle}>
                <span className={styles.stepNumberBadge}>A.</span> Current
                Strategy
              </p>
              <ul className={styles.helpList}>
                <li>
                  <strong>Current Strategy:</strong> Displays the active strategy
                  (e.g., "CryptoCrispy Trading Strategy," AI-powered, predefined).
                </li>
              </ul>
              <div className={styles.imageWrap}>
                <LazyLoadImage
                  src={str2}
                  alt="create bot"
                  effect="blur"
                  wrapperClassName="imageContainer"
                />
              </div>
            </div>
          </div>

          <div className={styles.subSection}>
            <div className={`${styles.subSectionBadge} ${styles.subSectionBadge2}`}>
              <MdOutlineTableView />
            </div>
            <div className={styles.subStepContainer}>
              <p className={styles.subStepTitle}>
                <span className={`${styles.stepNumberBadge} ${styles.stepNumberBadge2}`}>B.</span> Asset-Specific Data
              </p>
              <ul className={styles.helpList}>
                <li>
                  <strong>Asset-Specific Data:</strong> Displays real-time price
                  and performance for each asset. For example, BNB/USDT 693.28
                  +18.99 (+2.82%) means that 1 BNB is currently worth 693.28 USDT.
                  The price has increased by 18.99 USDT over the past 24 hours,
                  which is a 2.82% gain. This helps you quickly see how each asset
                  is performing in the market.
                </li>
              </ul>
              <div className={styles.imageWrap}>
                <LazyLoadImage
                  src={str3}
                  alt="ai assistant"
                  effect="blur"
                  wrapperClassName="imageContainer"
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className={styles.stepContainer}>
        <div className={styles.stepHeader}>
          <div className={`${styles.stepNumWrap} ${styles.stepNumInsight}`}>
            <span className={styles.stepNum}>3</span>
          </div>
          <div className={styles.stepInfo}>
            <h4 className={styles.stepTitle}>Signals Table & Place Order</h4>
            <div className={`${styles.stepTag} ${styles.tagTrade}`}>
              <MdOutlineShoppingCart />
              Trading Actions
            </div>
          </div>
        </div>
        <div className={styles.subStepWrapper}>
          <div className={styles.subStepContainer}>
            <p className={styles.helpLead}>
              The table displays detailed trading signals for each asset:
            </p>
            <ul className={styles.helpList}>
              <li>
                <strong>Place Order:</strong> Suggested action (Buy/Sell) with a
                confidence percentage
              </li>
            </ul>
            <div className={styles.imageWrap}>
              <LazyLoadImage
                src={str4}
                alt="create bot"
                effect="blur"
                wrapperClassName="imageContainer"
              />
            </div>

            <div className={styles.calloutBox}>
              <MdOutlineAddTask />
              <p className={styles.calloutText}>
                Click Run to execute the 15m suggested sinal for each asset.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default InsightStrategyHelp;
